import coreApi from './coreApi';
import type { UserProfile } from '../types/profile';

export const profileApi = {
  async getProfile() {
    const response = await coreApi.get('/profile');
    return response.data.profile;
  },

  async updateProfile(updates: Partial<UserProfile>) {
    const response = await coreApi.put('/profile', updates);
    return response.data.profile;
  },

  async getPreferredBible() {
    try {
      const response = await coreApi.get('/profile/preferred-bible');
      return { bible: response.data.preferredBible, error: null };
    } catch (error) {
      console.error('Error fetching preferred bible:', error);
      return { bible: 'en-kjv', error };
    }
  },

  async getBookmarks() {
    const response = await coreApi.get('/profile/bookmarks');
    return response.data;
  },

  async toggleBookmark(bookmark: {
    verse: { book: string; chapter: string; verse: string };
    reference: string;
  }) {
    const response = await coreApi.post('/profile/bookmarks', bookmark);
    return response.data;
  },

  async deleteBookmark(bookmarkId: string) {
    const response = await coreApi.delete(`/profile/bookmarks/${bookmarkId}`);
    return response.data;
  },

  async getReadingPosition() {
    const response = await coreApi.get('/profile/reading-position');
    return response.data;
  },

  async saveReadingPosition(book: string, chapter: string) {
    const response = await coreApi.post('/profile/reading-position', { book, chapter });
    return response.data;
  }
};
